import {
  ADD_PARTNER_EMPLOYEE,
  EDIT_PARTNER_EMPLOYEE,
  DELETE_PARTNER_EMPLOYEES,
  SET_PAGE_DATA,
  SET_TOTAL_RECORDS,
  SET_PAGE,
  PARTNER_EMPLOYEES_LOADING,
  PARTNER_EMPLOYEES_FAILURE,
  GET_PARTNER_EMPLOYEES,
  SET_REDIRECT_URL,
  VIEWING_PARTNER_INFO,
} from "./partner-employee-constant";
import {
  handleLoading,
  handleFailure,
  handleSetRedirectUrl,
  handleGetData,
  handleSetTotalRecords,
  handleSetPage,
  handleEditItem,
  handleAddItem,
  handleDeleteItems,
} from "../utils/reducerUtils";

// Initial state
const initialState = {
  employeeList: {},
  totalRecords: 0,
  totalPages: 0,
  currentPage: 1,
  loading: false,
  error: null,
  redirectTo: false,
  viewingPartnerInfo: null,
};

export const partnerEmployeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case PARTNER_EMPLOYEES_LOADING:
      return handleLoading(state, action);

    case PARTNER_EMPLOYEES_FAILURE:
      return handleFailure(state, action);

    case SET_REDIRECT_URL:
      return handleSetRedirectUrl(state, action);

    case GET_PARTNER_EMPLOYEES:
      return handleGetData(state, action, "employeeList");

    case SET_TOTAL_RECORDS:
      return handleSetTotalRecords(state, action);

    case SET_PAGE:
      return handleSetPage(state, action);

    case EDIT_PARTNER_EMPLOYEE:
      return handleEditItem(state, action, "employeeList", "partnerEmployeeId");

    case ADD_PARTNER_EMPLOYEE:
      return handleAddItem(state, action, "employeeList", "partnerEmployeeId");

    case DELETE_PARTNER_EMPLOYEES:
      return handleDeleteItems(state, action, "employeeList", "partnerEmployeeId");
    case VIEWING_PARTNER_INFO:
      return { ...state, viewingPartnerInfo: action.payload };
    default:
      return state;
  }
};
